import React, { useEffect } from 'react';
import { pageContext } from 'ctm-util-functions';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { getWelcomeBackHeroImageUrl } from 'ctm-selectors/selectors/brand_content';
import { getSavedSince, REDIRECT_DELAY_MS } from 'ctm-components/components/prefill/utils';
import { PrefillQuoteCTAButtons } from './prefill_quote_cta_buttons';
import { Picture } from '../picture/picture';
import { useStyles } from './prefill_styles';
import { BackButton } from '../back_button/back_button';

const HeroImage = ({ url, classNames }) => {
    if (!url) return null;

    const pictureSchema = {
        elementProps: {
            source: [{
                srcSet: url
            }],
            image: {
                alt: 'Hero Image',
                src: url,
                title: 'Hero Image'
            }
        }
    };

    return <Picture className={classNames} {...pictureSchema} />;
};

HeroImage.propTypes = {
    url: PropTypes.string,
    classNames: PropTypes.string
};

export const PrefillWelcomeBackSplash = ({ autoResume, resumeQuoteFunc, continueNewQuote, lastAccessedDate, withBackButtonBottom, children }) => {
    const vertical = pageContext.getVertical();
    const classes = useStyles({ vertical });

    const heroImageUrl = useSelector(getWelcomeBackHeroImageUrl);
    const savedDate = getSavedSince(lastAccessedDate);
    // TODO: Rework when WelcomeBack page is further along
    // This might be used depending on how navigation works out
    const getBackButton = () => {
        const contentProps = { label: 'Back', iconPosition: 'before', icon: 'ctm_angle_left' };
        const elementProps = { tagName: 'a', href: 'javascript:;' };
        return (
            <BackButton
                className={withBackButtonBottom ? classes.backButtonBottom : classes.backButton}
                contentProps={contentProps}
                elementProps={elementProps}
            />
        );
    };

    useEffect(() => {
        let timer;
        if (autoResume) {
            timer = setTimeout(() => {
                resumeQuoteFunc();
            }, REDIRECT_DELAY_MS);
        }
        return () => {
            if (timer) clearTimeout(timer);
        };
    }, [autoResume, resumeQuoteFunc]);

    return (
        <div className={classes.splashWrapper}>
            <HeroImage url={heroImageUrl} classNames={classes.hero} />
            <div className={classes.splashHeaderWrapper}>
                <p className={classes.splashHeader}>Welcome back!</p>
                { autoResume ? (
                    <h2 className={classes.splashText}>
                        Retrieving your quotes
                    </h2>
                ) : (
                    <h2 className={classes.splashText}>
                        We've saved your progress to
                        <br />
                        help make things&nbsp;easier
                    </h2>
                )}
                {savedDate && (
                    <p className={classes.savedText}>
                        {savedDate}
                    </p>
                )}
            </div>
            {children}
            {!autoResume && <PrefillQuoteCTAButtons continueDisabled={false} continueNewQuote={continueNewQuote} resumeQuoteFunc={resumeQuoteFunc} />}
            {!autoResume && getBackButton()}
        </div>
    );
};

PrefillWelcomeBackSplash.propTypes = {
    resumeQuoteFunc: PropTypes.func.isRequired,
    continueNewQuote: PropTypes.func,
    lastAccessedDate: PropTypes.string,
    withBackButtonBottom: PropTypes.bool,
    autoResume: PropTypes.bool,
    children: PropTypes.node
};
